export const SET_PROJECT = 'SET_PROJECT';
export const RESET_PROJECT_DATA = 'RESET_PROJECT_DATA';
export const SET_IMAGES = 'SET_IMAGES';
export const SET_TITLE = 'SET_TITLE';
export const SET_DESCRIPTION = 'SET_DESCRIPTION';



// WEBPACK FOOTER //
// ./src/screens/App/store/types.js